import styled, { keyframes } from 'styled-components'
import journalIcon from 'src/assets/journal_icon.png'
import {
  ButtonBase,
  Drawer,
  IconButton,
  ListItem,
  ListItemText,
  Menu,
  styled as muiStyled,
} from '@mui/material'

export const NotificationIconButton = muiStyled(IconButton)(
  ({ theme }) => `
      display: relative;
      background: transparent;
      color: #9596f7;
      &:hover {
          background: transparent;
      }
  `,
)

export const NotificationMenuComponent = muiStyled(Menu)(
  ({ theme }) => `
    margin-top:10px;
    // margin-left: 108px;
  
    .MuiMenu-paper{
      border-radius: 10px;
      max-height: calc(100vh - 90px);
      max-width: 315px;
      width: 100%;
      ::-webkit-scrollbar-track {
          -webkit-box-shadow: unset;
          background-color: #f0f0f2;
          border-radius: 10px;
        }
      ::-webkit-scrollbar {
          width: 10px;
          border-radius: 10px;
          background-color: #fff;
        }
      ::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #bcc0c4;
        }
    }
  `,
)

export const NotificationMenuHeading = muiStyled('div')(
  ({ theme }) => `
    font-size: 20px;
    font-weight: 700;
    padding: 4px 0px 12px 14px;
  `,
)

export const NotificationListItemPrimary = muiStyled('div')(
  ({ theme }) => `
    font-weight:600;
    font-size: 14px;
  `,
)
export const NotificationListItemSecondary = muiStyled('div')(
  ({ theme }) => `
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: normal;
    font-size: 13px;
  `,
)
export const NotificationListItemTime = muiStyled('div')(
  ({ theme, read }) => `
      font-size: 12px;
      color: ${read ? '#868686' : '#8266ff'};
      font-weight: 600;
  `,
)

export const NotificationContextMenuActionButton = muiStyled(IconButton)(
  ({ theme, showButton }) => `
    display: ${showButton ? 'flex' : 'none'};
    border: 1px solid #c6c6c6;
    position: absolute;
    z-index: 999;
    right: 15px;
    box-shadow: 0 0 10px -6px #000;
    background: #fff;
    &:hover {
      background: #f2f2f2;
    }
  `,
)

export const NotificationMenuItemContainer = muiStyled('div')(
  ({ theme }) => `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &:hover {
    .MuiIconButton-root {
      display: flex;
    }
  }
  `,
)

export const NotificationListItemContainer = muiStyled('div')(
  ({ theme, read }) => `
    padding: 6px 0px;
    width: 100%;
    display:flex;
    flex-direction: column;
    gap: 5px;
    ${read ? 'color: #868686 !important;' : ''}
  `,
)
export const NotificationListItemText = muiStyled(ListItemText)(
  ({ theme }) => `
    width: 100%;
    .MuiListItemText-secondary {
      text-overflow: ellipsis;
      word-wrap: normal;
      white-space: unset;
      overflow: hidden;
    }
  `,
)
